import flowRight from 'lodash/flowRight';
import { connect } from 'react-redux';
import { signInFetch } from '@zocdoc-frontend-common/components-sign-in-form/signInFormActions';
import {
    setupCssTransitionToNextPage,
    setupCssTransitionToPrevPage,
} from 'src/Booking/actions/SignUpActions';
import { AccountType, INITIAL_BOOKING_ROOT_KEY } from 'src/Booking/constants';
import { BookingPathKeys, paths } from 'src/Booking/paths';
import { pushWithQuery } from 'src/Booking/utils';
import buildSsoReturnUrl from 'src/Booking/utils/buildSsoReturnUrl';
import { getReferrerType } from 'src/Booking/utils/getReferrerType';
import { pinataEmailFirstSelector } from 'src/config/ab/selector';
import CreateAccountContainer, {
    CreateAccountNavigationContext,
} from './CreateAccountContainer';

const mapStateToProps = (state, ownProps) => {
    const { socialUserDetails } = state[INITIAL_BOOKING_ROOT_KEY];
    const ssoReturnUrl = buildSsoReturnUrl(
        ownProps.bookingId,
        getReferrerType()
    );

    const collectEmailFirst = pinataEmailFirstSelector(state);

    return {
        collectEmailFirst,
        socialUserDetails,
        ssoReturnUrl,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    goBackToPage: (targetPath) => {
        dispatch(setupCssTransitionToPrevPage());
        dispatch(pushWithQuery(`${targetPath}/${ownProps.bookingId}`));
    },
    onSubmitPatientInfoSuccess: () => {
        const nextPath = ownProps.collectEmailFirst
            ? paths[BookingPathKeys.createUsernamePath]
            : paths[BookingPathKeys.signUpPath];
        dispatch(setupCssTransitionToNextPage());
        dispatch(pushWithQuery(`${nextPath}/${ownProps.bookingId}`));
    },
    onSubmitCreateUsernameSuccess: () => {
        dispatch(
            pushWithQuery(
                `${paths[BookingPathKeys.createPasswordPath]}/${
                    ownProps.bookingId
                }`
            )
        );
    },
    onSubmitSignUpSuccess: ({ email, password, rememberMe }) => {
        if (
            ownProps.socialUserDetails &&
            ownProps.socialUserDetails.account_type !== AccountType.Default &&
            typeof window !== 'undefined'
        ) {
            window.location.assign(ownProps.ssoReturnUrl);
        } else if (!password) {
            // Skip password
            dispatch(
                pushWithQuery(
                    `${paths[BookingPathKeys.reviewAndBookPath]}/${
                        ownProps.bookingId
                    }`
                )
            );
        } else {
            dispatch(signInFetch(email, password, rememberMe));
        }
    },
});

export { CreateAccountNavigationContext };

// mapDispatchToProps uses props from mapStateToProps so we need 2 connects
export default flowRight(
    connect(mapStateToProps, null),
    connect(null, mapDispatchToProps)
)(CreateAccountContainer);
